/** User-facing message from a failed API response (JSON `message` / `title` when present). */
export async function messageFromFailedResponse(response: Response, fallback: string): Promise<string> {
  const status = response.status;
  let detail = '';
  try {
    const json = await response.clone().json();
    const raw = json?.message ?? json?.error ?? json?.title;
    if (typeof raw === 'string' && raw.trim()) detail = raw.trim();
  } catch {
    /* non-JSON body */
  }

  if (detail) {
    return status ? `${detail} (${status})` : detail;
  }

  if (status === 405) {
    return `${fallback} The server does not allow this action yet (405).`;
  }

  if (status) {
    return `${fallback} (${status})`;
  }

  return fallback;
}
